import { TourOfferDeparture } from '~/types/tours/tourOffer';

// Bundles sell single and double: one single space, or two twin-share spaces.
const SPACES_NEEDED: ReadonlyArray<{ roomType: string; spaces: number }> = [
  { roomType: 'single', spaces: 1 },
  { roomType: 'twin', spaces: 2 },
];

export function spacesLeft(departure: TourOfferDeparture | undefined, roomType: string): number {
  return departure?.roomAvailability.find((room) => room.roomType === roomType)?.spacesLeft ?? 0;
}

/** Whether the tour can take both a single and a double on this departure. */
export function isTourAvailable(departure: TourOfferDeparture | undefined): boolean {
  return SPACES_NEEDED.every(({ roomType, spaces }) => spacesLeft(departure, roomType) >= spaces);
}

const BUNDLE_CURRENCY = 'AUD';

/**
 * The tour's price for one occupancy: a single room, or two twin-share places. svc-tour gives
 * the per-person price of the cheapest configuration and package. Undefined when it isn't priced.
 */
export function tourPrice(departure: TourOfferDeparture | undefined, occupancy: number): number | undefined {
  const roomType = occupancy === 1 ? 'single' : 'twin';
  const perPerson = departure?.roomPrices.find(
    (room) => room.roomType === roomType && room.currency === BUNDLE_CURRENCY,
  )?.price;
  return perPerson === undefined ? undefined : perPerson * occupancy;
}
